import { useCallback, useEffect, useState } from 'react';

import { FileAttachment } from '../../../db/types';
import {
  fileAttachmentComparer,
  uploadFormula as _uploadFormula,
  uploadImage as _uploadImage,
} from '../helpers';
import { UseRichTextEditor } from './types';

const INITIAL_ATTACHMENTS: FileAttachment[] = [];

export default function useRichTextEditor({
  initialAttachments = INITIAL_ATTACHMENTS,
  onAttachmentsChange,
}: UseRichTextEditor) {
  const [uploadingImageCount, setUploadingImageCount] = useState(0);
  const [attachments, setAttachments] = useState(initialAttachments);

  const uploadFormula = useCallback(_uploadFormula, []);

  const uploadImage = useCallback(async (file: File) => {
    try {
      setUploadingImageCount((count) => count + 1);
      const result = await _uploadImage(file);
      return result;
    } finally {
      setUploadingImageCount((count) => count - 1);
    }
  }, []);

  const handleAttachmentUpload = (attachment: FileAttachment) => {
    onAttachmentsChange?.([...attachments, attachment]);
    setAttachments((attachments) => [...attachments, attachment]);
  };

  const handleAttachmentDelete = (attachment: FileAttachment) => () => {
    onAttachmentsChange?.(attachments.filter((a) => !fileAttachmentComparer(a, attachment)));
    setAttachments((attachments) => attachments.filter((a) => !fileAttachmentComparer(a, attachment)));
  };

  useEffect(
    function resetAttachments() {
      setAttachments(initialAttachments);
    },
    [initialAttachments]
  );

  return {
    attachments,
    isUploadingImage: uploadingImageCount > 0,
    onAttachmentUpload: handleAttachmentUpload,
    onAttachmentDelete: handleAttachmentDelete,
    uploadFormula,
    uploadImage,
  };
}
